import styled from 'styled-components'

export default styled.input`
  height: 40px;
  width: 100%;
  border: ${props => (props.error ? '1px solid #fa4624' : 0)};
  font: normal 20px/26px 'chaparral-pro', serif;
  padding: ${props =>
    props.error ? '7px 14px 5px 14px' : '8px 15px 6px 15px'};
  margin-bottom: 21px;

  outline: none;

  :focus {
    padding: 7px 14px 5px 14px;
    border: 1px solid ${props => (props.error ? '#fa4624' : '#4d90fe')};
  }
`



// WEBPACK FOOTER //
// ./components/atoms/input.js